import axiosInstance from "../config/axios.config";

export const getPharmacyMedicinesListApi = (params) => {
  return axiosInstance.get(`pharmacy/medicines/?${params}`);
};

export const addPharmacyMedicineApi = (payload) => {
  return axiosInstance.post(`pharmacy/medicines/`, payload);
};

export const updatePharmacyMedicineApi = (id, payload) => {
  return axiosInstance.patch(`pharmacy/medicines/${id}/`, payload);
};

export const getPharmacyMedicineApi = (id) => {
  return axiosInstance.get(`pharmacy/medicines/${id}/`);
};

export const getPharmacyMedicineBatchesApi = (id) => {
  return axiosInstance.get(`pharmacy/medicines/${id}/batches/`);
};

export const getPharmacyMedicineAllBatchesApi = (id) => {
  return axiosInstance.get(`pharmacy/medicines/${id}/batches/all/`);
};

export const updatePharmacyMedicineBatchApi = (medicineId, batchId, payload) => {
  return axiosInstance.patch(`pharmacy/medicines/${medicineId}/batches/${batchId}/`, payload);
};

export const searchPharmacyMedicinesApi = (params) => {
  return axiosInstance.get(`pharmacy/search/medicines/?${params}`);
};

export const searchPharmacyCompaniesApi = (params) => {
  return axiosInstance.get(`pharmacy/search/companies/?${params}`);
};

export const searchPharmacySaltsApi = (params) => {
  return axiosInstance.get(`pharmacy/search/salts/?${params}`);
};

export const searchPharmacyHSNAndSACApi = (params) => {
  return axiosInstance.get(`pharmacy/search/hsn-and-sac/?${params}`);
};

/**
 * Counter-sale customers are facility-specific, so the `facility` header the
 * axios client already attaches scopes the result. `field` selects which column
 * the query matches.
 */
export const searchCounterSaleCustomersApi = (params) => {
  return axiosInstance.get(`pharmacy/counter-sale-customers/search/?${params}`);
};

/**
 * Every order this medicine has been put on - who asked for it, how much went
 * out, and what it came to. Takes the pharmacy medicine's own id, the same one
 * `getPharmacyMedicineApi` takes.
 */
export const getPharmacyMedicineOrdersApi = (id, params) => {
  return axiosInstance.get(`pharmacy/medicines/${id}/orders/${params ? `?${params}` : ""}`);
};
